import { actionTypes, UserSetAction, TokenSetAction, AuthStatusSetAction, ActionTypes, AuthAssumeRoleFromUserAction } from './actions'
import { User } from '../../lib/interfaces/User.interface';

export type AuthStatus = 'initial' | 'authenticating' | 'authed' | 'error'

export interface AuthState {
  readonly user?: User
  readonly status: AuthStatus
  readonly accessToken: string
  readonly assumingRoleFrom?: User
}

export const initialState: AuthState = {
  user: undefined,
  accessToken: '',
  status: 'initial'
}

export function reducer(state: AuthState = initialState, action: ActionTypes): AuthState {
  switch (action.type) {
    case actionTypes.AUTH_TOKEN_SET:
      return {
        ...state,
        accessToken: (action as TokenSetAction).payload.accessToken,
        status: 'authenticating',
      }

    case actionTypes.AUTH_USER_SET:
      return {
        ...state,
        user: (action as UserSetAction).payload.user,
      }

    case actionTypes.AUTH_ERROR:
      return {
        ...state,
        status: 'error',
      }

    case actionTypes.AUTH_STATUS_SET: {
      const statusSetAction = action as AuthStatusSetAction

      return {
        ...state,
        status: statusSetAction.payload.status
      }
    }

    case actionTypes.AUTH_ASSUME_ROLE: {
      const assumeRoleAction = action as AuthAssumeRoleFromUserAction

      return {
        ...state,
        user: {
          ...state.user!,
          assumingRoleFrom: assumeRoleAction.payload.user
        }
      }
    }

    case actionTypes.AUTH_LOGOUT:
      return {
        ...initialState,
      }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/store/auth/reducer.ts